import React from 'react'
import { Layout, Typography, Space, Divider } from 'antd'
import { 
  GithubOutlined, 
  BookOutlined,
  HeartFilled 
} from '@ant-design/icons'
import './Footer.css'

const { Footer: AntFooter } = Layout
const { Text, Link } = Typography

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <AntFooter className="site-footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-section">
            <h4 className="footer-title">
              <BookOutlined /> 五千年文库
            </h4>
            <p className="footer-description">
              中国古代文献数字化平台，传承千年文化，让古籍触手可及。
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">快速链接</h4>
            <ul className="footer-links">
              <li><Link href="/">首页</Link></li>
              <li><Link href="/books">书籍浏览</Link></li>
              <li><Link href="/search">全文搜索</Link></li>
              <li><Link href="/admin">后台管理</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">文献分类</h4>
            <ul className="footer-links">
              <li><Link href="/category/jing">经部</Link></li>
              <li><Link href="/category/shi">史部</Link></li>
              <li><Link href="/category/zi">子部</Link></li>
              <li><Link href="/category/ji">集部</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">关于项目</h4>
            <Space direction="vertical" size="small">
              <Link href="https://github.com/ancient-books" target="_blank">
                <GithubOutlined /> 源代码
              </Link>
              <Text type="secondary">基于 Cloudflare 技术栈</Text>
              <Text type="secondary">开源免费，持续更新</Text>
            </Space>
          </div>
        </div>
        
        <Divider className="footer-divider" />
        
        <div className="footer-bottom">
          <Text type="secondary">
            © {currentYear} 五千年文库. 致力于传承中华文化
          </Text>
          <Text type="secondary" className="footer-love">
            Made with <HeartFilled style={{ color: '#ff4d4f' }} /> for Chinese Literature
          </Text>
        </div>
      </div>
    </AntFooter>
  )
}

export default Footer